import { NgModule } from "@angular/core"
import { RouterModule } from "@angular/router"
import { Routes } from "@angular/router"

import { BrowseByGradeComponent } from "./browse-by-grade.component"
import { ErrorComponent } from "../error/error.component"
import { ErrorModule } from "../error/error.module"
import { GradeAccessGuards } from "../guards/GradeAccess.guards"

const browseByGrade: Routes = [
    { path: ":grade", component: BrowseByGradeComponent, canActivate: [GradeAccessGuards] },
    { path: "**", component: ErrorComponent },
]

@NgModule({
    imports: [RouterModule.forChild(browseByGrade), ErrorModule],
    exports: [RouterModule],
})
export class BrowseByGradeRoutingModule {}
